/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const linkTelegramRequestSchema = z.object({
  initData: z.string().min(1),
});

export type ILinkTelegramRequest = z.infer<typeof linkTelegramRequestSchema>;
